import styled from "styled-components"
import {  useState } from "react";


let CardTitle = styled.h1`
    position: absolute;
    top: 30px;
    left: 30px;
    font-size: 25px;
    color: white;
    text-shadow: 2px 2px 5px black;

    @media screen and (max-width: 600px){
        font-size: 16px;
        left: 15px;      
    }
`

let CardContainer = styled.div`
    position: relative;
    flex: 1 0 20%;
    height: 200px;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 20px;
    border: thin solid black;

    

    ${(props) => {
        return props.hasFlipped ? "background-color: none;" : "background-color: beige;"
    }}
`

let CardImage = styled.img`
    width: 100%;
    height: 100%;
    opacity: 0.5;
    border-radius: 20px;
    object-fit: cover;
`

const CardButton = styled.button`
    position: absolute;
    bottom: 30px;
    left: 25%;
    width: 50%;
    font-size: 20px;
    font-family: Georgia;
    padding: 10px 40px;
    border: none;
    border-radius: 15px;

    @media screen and (max-width: 900px){
        font-size: 20px;
        left: 20%; 
        width: 60%;    
        padding: 10px 5px; 
    }

    ${(props) => 
        {return props.isFlipped ? `
            color: dodgerblue;
            background-color: white;
        
        ` : `
            color: white;
            background-color: dodgerblue;
        `;}
    }

`

/**
 * 
 * Need to keep track of flipped state in master board
 */
const MGCard = (props) => {
    
    
    const [guitarInfo,setGuitarInfo] = useState(props.guitarInfo)
    const [cImage,setImage] = useState(guitarInfo.image)
    const [cTitle,setTitle] = useState(guitarInfo.name)

    return (<CardContainer hasFlipped={guitarInfo.isFlipped}>
        {guitarInfo.isFlipped &&  <CardImage src={cImage}/>}
       
        <CardTitle>{ guitarInfo.isFlipped ? cTitle : "Secret Animal"}</CardTitle>
        <CardButton isFlipped={guitarInfo.isFlipped} onClick={() => {
        
            props.flip(props.cardIndex);
        } }>Flip</CardButton>
    </CardContainer>);
}

export default MGCard